import { render, staticRenderFns } from "./RelatorioPaciente.vue?vue&type=template&id=5e668f13&scoped=true"
import script from "./RelatorioPaciente.vue?vue&type=script&lang=js"
export * from "./RelatorioPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e668f13",
  null
  
)

export default component.exports